import BaseListPage from "../../../../base/BaseListPage";
import withRouter from "../../../../withRouter";
import {
  countObjectUseCase,
  findObjectUseCase,
} from "../../../../usecases/object";
import TransTypeDistributionPresenter from "./TransTypeDistributionPresenter";
import Export from "../../../../components/Export";
import printChart from "../../../../PrintChart";
import DateRangeReport from "../../../../components/DateRangeReport";
import DefaultState from "../../../sales-and-transactions/components/DefaultState";
import InitialPrompt from "../../../../components/InitialPrompt";
import SalesPieReport from "./components/SalesPieReport";
import { exportTransactionTypeDistributionCSV } from "./utils/transactionTypeDistributionCsvUtils";
import ProgressLoader from "../../../../components/ProgressLoader";
import PageHeader from "../../../../components/PageHeader";
import CustomSelect from "../../../../components/CustomSelect";

class TransTypeDistributionPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new TransTypeDistributionPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
    );
    this.state = {
      objects: [],
      startDate: "",
      endDate: "",
      selectedStoreCode: "",
      store: [],
      storess: "",
      range: "",
      notFound: false,
    };
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleStoreCodeChange = this.handleStoreCodeChange.bind(this);
  }

  getCollectionName() {
    return "transactions";
  }

  setStore(store) {
    this.setState({ store });
  }

  onChangeStore(where) {
    this.setState({ storess: where });
    this.presenter.onChangeStore(where);
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  getUniqueStoreCodes() {
    const storeCodes = this.state.objects.map((obj) => {
      return obj.store_code.replace("ANGELSPIZZA_", "");
    });

    return [...new Set(storeCodes)]; // Remove duplicates
  }

  handleStartDateChange(event) {
    this.setState({ startDate: event.target.value });
  }

  handleEndDateChange(event) {
    this.setState({ endDate: event.target.value });
  }

  handleStoreCodeChange(event) {
    this.setState({ selectedStoreCode: event.target.value });
  }

  filterTransactions() {
    const { objects, startDate, endDate, selectedStoreCode } = this.state;

    return objects
      .filter((status) => status.status === "C")
      .filter((transaction) => {
        const transactionDate = new Date(transaction.createdAt);
        const start = startDate
          ? new Date(startDate)
          : new Date(-8640000000000000);
        const end = endDate ? new Date(endDate) : new Date();
        end.setHours(23, 59, 59, 999);
        const isDateInRange =
          (!startDate || transactionDate >= start) &&
          (!endDate || transactionDate <= end);
        const isStoreCodeMatch = selectedStoreCode
          ? transaction.store_code === `ANGELSPIZZA_${selectedStoreCode}`
          : true;

        return isDateInRange && isStoreCodeMatch;
      });
  }

  chartData() {
    const filteredTransactions = this.filterTransactions();

    const knownTypes = {
      D: "Dine-in",
      T: "Take-out",
      G: "GrabFood",
      U: "Delivery",
      K: "Drive-Thru",
      F: "FoodPanda",
      P: "Pickup",
      B: "Bulk Order",
    };

    const colors = [
      "#1b74bb", "#37c6f4", "#ffcf39", "#f472b6",
      "#22c55e", "#db3373", "#ff9f40", "#9966ff",
      "#4bc0c0", "#ea4335",
    ];

    const countMap = {};

    filteredTransactions.forEach((item) => {
      const t = item?.tran_type;
      if (!t) return;
      if (!countMap[t]) countMap[t] = 0;
      countMap[t]++;
    });

    const entries = Object.entries(countMap).filter(([, count]) => count > 0);

    const labels = entries.map(([code]) => knownTypes[code] || code);
    const data = entries.map(([, count]) => count);
    const backgroundColor = entries.map((_, i) => colors[i % colors.length]);

    return {
      labels,
      datasets: [
        {
          label: "Transaction Types",
          data,
          backgroundColor,
        },
      ],
    };
  }

  chartOption() {
    return {
      responsive: true,
      maintainAspectRatio: false,
      aspectRatio: 2,
      plugins: {
        legend: {
          position: "top",
        },
        title: {
          display: true,
          text: "Transaction Type Distribution",
        },
      },
    };
  }

  exportToCSV = () => {
    const { range, storess } = this.state;
    const chartData = this.chartData(this.state.objects);

    exportTransactionTypeDistributionCSV({
      chartData,
      storeName: storess,
      range,
      // fileName: 'CustomFilename.csv'
    });
  };

  getProgressPercentage() {
    const { objects, count } = this.state;
    if (!count || count === 0) return 0;
    return Math.min(Math.round((objects.length / count) * 100), 100);
  }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  render() {
    const { objects, storess, range } = this.state;

    const data = this.chartData(objects);
    const options = this.chartOption();

    const chartId = "chart-container9";
    const formatSales = (sales) => {
      return sales.toLocaleString("en-US", {
        style: "currency",
        currency: "PHP",
      });
    };

    const storeOptions = [
      { value: "AllStore", label: "All Store" },
      ...this.state.store.map((code) => ({
        value: code.name,
        label: code.name,
      })),
    ];

    const selectedOption = storeOptions.find(
      (opt) => opt.value === this.state.selectedStoreCode,
    );

    return (
      <>
        <div className="d-flex justify-content-between align-items-center mb-1 mt-4">
          <PageHeader
            title="Transaction Type Distribution"
            subtitle="Breakdown of transactions by type"
            icon="bi bi-pie-chart"
          />
          <Export
            exportCsv={this.exportToCSV}
            exportPdf={() => printChart(chartId)}
          />
        </div>
        <div className="row mb-2">
          <div className="col" style={{ maxWidth: "max-content" }}>
            <DateRangeReport
              onChange={this.onChangeDate.bind(this)}
              field="tran_date"
            />
          </div>
          <div className="col-sm-4">
            <CustomSelect
              label="Store"
              options={[
                // { value: "AllStore", label: "All Store" },
                ...this.state.store.map((store) => ({
                  value: store.name,
                  label: store.name.replace(/_/g, " "),
                })),
              ]}
              onChange={(selected) => this.onChangeStore(selected.value)}
              isDisabled={!this.state.range}
              error={
                !this.state.range ? "Please select a date range first" : ""
              }
              icon="bi bi-shop"
              placeholder="Select Store"
              isClearable={true}
            />
          </div>
        </div>

        {this.state.objects && this.state.objects.length > 0 ? (
          <>
            <ProgressLoader
              loaded={this.state.objects?.length}
              total={this.state.count}
              getProgressPercentage={() => this.getProgressPercentage()}
            />
            <SalesPieReport
              data={data}
              options={options}
              formatSales={formatSales}
              storess={storess}
              range={range}
              chartRef={this.chartRef9}
              containerId="chart-container9"
            />
          </>
        ) : this.state.notFound ? (
          <div className="text-center mt-5">
            <p className="text-muted fs-5">
              📭 Data not found for selected filter.
            </p>
          </div>
        ) : this.state.storess && this.state.range && !this.state.notFound ? (
          <div className="text-center mt-5">
            <DefaultState />
          </div>
        ) : (
          <InitialPrompt twoFilter={true} />
        )}
      </>
    );
  }
}

export default withRouter(TransTypeDistributionPage);
